import type { Ref } from 'react';
import { createContext } from 'react';

interface StudioDeviationListContextProps {
  tagsColRef?: Ref<HTMLDivElement>;
  tagsColWidth?: number;
  actionsColRef?: Ref<HTMLDivElement>;
  actionsColWidth?: number;
}

export const StudioDeviationListContext = createContext<StudioDeviationListContextProps>({});
